export default __webpack_public_path__ + "static/media/servicesBannerAr.e05111d4.jpg";